import React,{Component} from 'react'
import {Avatar ,Typography ,Button , Row ,Col, Spin} from 'antd'
import titleStore from './../store/TitleStore'
import dispatcher from '../dispatcher/dispatcher';
import authStore from '../store/AuthStore';
import {getProfile} from '../redux/auth/actions/actionCreators'
import {logout} from '../redux/auth/actions/actions'
import { connect } from 'react-redux';

const {Title} = Typography;



class LoginDetails extends Component{

    constructor(){
        super();
        this.state = {
            title : titleStore.getTitle(),
            user: "",
            authStore : authStore.initialState
        }
    }

    handleClick = () => {
        console.log("hi")
    }

    handleLogout = () =>{
        this.props.logout()
    }

    componentDidMount(){
        this.props.getProfile(this.props.server,this.props.auth.token)

        // authStore.on('update',()=>{
        //     this.setState({authStore:authStore.initialState})
        // })

        titleStore.on('change',()=>{
            this.setState({title:titleStore.getTitle()})
        })

    }
    
    


    render(){

        const {profile} = this.props

        return(    
            profile ?
            <Spin spinning={this.props.loading}>
                <div>
                    <Row>
                        <Col span={10}>
                            <Title  level={4} style={{display:"inline" , textAlign:"left"}}> {this.state.title} </Title>
                        </Col>

                        <Col style={{textAlign:"right"}} span={14}>
                            <div style={{textAlign:"right", display:"inline"}} >
                                <div style={{cursor:"pointer" , display:"inline"}}>
                                    <Avatar onClick={this.handleClick}  shape = "square" style={{backgroundColor:"red" , marginRight:"10px" , cursor:"pointer"}} src="img/login_icon.png" />
                                    <span >Hi, {profile.Contact.FirstName} </span>
                                </div>   
                                <Button type="danger" ghost style={{margin:"5px"}} onClick={this.handleLogout}>Logout</Button>                   
                            </div>
                        </Col>
                    </Row>
                </div>
            </Spin>
            :<></>
            
        )
    }


}

const mapDispatchToProps = dispatch => {
    return {
        getProfile : (server,token) => dispatch(getProfile(server,token)),
        logout : () => dispatch(logout())
    }
}

const mapStateToProps = state =>{
    return {
        loading : state.profile.loading,
        auth : state.auth.authData,
        profile : state.profile.profile,
        server : state.entity.server
    }
}



export  default connect(mapStateToProps,mapDispatchToProps)(LoginDetails) ;